import { Component } from '@angular/core'

@Component({
  selector: 'kdgh-page-section-title',
  templateUrl: './page-section-title.component.html',
  styleUrls: ['./page-section-title.component.scss'],
})
export class PageSectionTitleComponent {}
